import React, { useState } from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { profileData } from '../data/siteContent';

const Bio = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="relative py-20 bg-black">
      {/* DJ NEFF Logo Watermark */}
      <div className="absolute inset-0 opacity-5 pointer-events-none overflow-hidden">
        <div className="flex flex-col h-full justify-around">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="flex justify-around whitespace-nowrap">
              {[...Array(4)].map((_, j) => (
                <img
                  key={j}
                  src="https://customer-assets.emergentagent.com/job_professional-epk/artifacts/k20ff6ft_IMG_4353_2-removebg-preview.png"
                  alt=""
                  className="w-32 h-32 md:w-40 md:h-40 object-contain"
                />
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Bio Text */}
          <div className="space-y-6">
            <h2 className="text-5xl md:text-6xl font-black text-white mb-8">
              BIO
            </h2>
            
            {/* Short Bio - Always visible */}
            <div className="text-gray-300 leading-relaxed text-base md:text-lg">
              <p>{profileData.bio_short}</p>
            </div>

            {/* Learn More Button */}
            <Button
              onClick={() => setExpanded(!expanded)}
              className="bg-white text-black hover:bg-gray-200 px-8 py-3 font-bold transition-all duration-300 flex items-center gap-2"
            >
              {expanded ? (
                <>
                  SHOW LESS
                  <ChevronUp className="w-5 h-5" />
                </>
              ) : (
                <>
                  LEARN MORE
                  <ChevronDown className="w-5 h-5" />
                </>
              )}
            </Button>

            {/* Expanded Bio */}
            {expanded && (
              <div className="text-gray-300 leading-relaxed space-y-4 text-base md:text-lg mt-6 animate-fadeIn">
                {profileData.bio_full.split('\n\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            )}
          </div>

          {/* Bio Image - Always visible */}
          <div className="sticky top-24">
            <Card className="overflow-hidden border-4 border-white bg-transparent">
              <img
                src={profileData.bio_image}
                alt="DJ NEFF Professional"
                className="w-full h-auto object-cover grayscale hover:grayscale-0 transition-all duration-500"
              />
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bio;
